<template>
        <!-- Modal -->
        <div class="modal fade" id="createUserModal" tabindex="-1" aria-labelledby="createuserModalLabel" aria-hidden="true">
                <div class="modal-dialog">
                        <div class="modal-content">
                                <div class="modal-header">
                                        <h5 class="modal-title" id="exampleModalLabel">Crear usuario</h5>
                                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span>
                                        </button>
                                </div>
                                <div class="modal-body">
                                        <div v-if="state == 'form'">
                                        <form class="offset-1">
                                                <div class="form-group">
                                                        <label for="name">Nombre</label>
                                                        <input class="form-control" v-model="name" id="name" type="text" />
                                                </div>

                                                <div class="form-group">
                                                        <label for="last_name">Apellido</label>
                                                        <input class="form-control" v-model="last_name" 
                                                        id="last_name" type="text" />
                                                </div>

                                                <div class="form-group">
                                                        <label for="identification_document_number">
                                                                Documento de identificación
                                                        </label>
                                                        <input class="form-control" v-model="id" 
                                                        id="identification_document_number" type="text" />
                                                </div>

                                                <div class="form-group">
                                                        <label for="dependency">Dependencia</label>
                                                        <input class="form-control" v-model="institution" 
                                                        id="dependency" type="text" />
                                                </div>

                                                <div class="form-group">
                                                        <label for="username">Email</label>
                                                        <input class="form-control" v-model="email" id="username" type="text" />
                                                </div>

                                                <div class="form-group">
                                                        <label for="password">Contraseña</label>
                                                        <input class="form-control" v-bind:class="{'is-invalid':pass_error}"  v-model="password" 
                                                        id="password" type="password" />
                                                        <div class="invalid-feedback">
                                                                Las contraseñas no coinciden
                                                        </div>
                                                </div>

                                                <div class="form-group">
                                                        <label for="password_confirm">Confirmar contraseña</label>
                                                        <input class="form-control" v-bind:class="{'is-invalid':pass_error}"  v-model="password_confirm" 
                                                        id="confirm_password" type="password" />
                                                        <div class="invalid-feedback">
                                                                Las contraseñas no coinciden
                                                        </div>
                                                </div>

                                                <div class="form-group">
                                                        <label for="rol">Seleccione el rol del nuevo usuario</label>
                                                        <select name="rol" id="rol" v-model="rol" class="form-control">
                                                                <option value="3">Administrador del Sistema</option>
                                                                <option value="4">Consultor del sistema</option>
                                                        </select>
                                                </div>

                                        </form> 
                                        </div>
                                </div>
                                        <div v-if="state == 'load'">
                                                <img :src="require('@/assets/images/system/Spinner.gif')" class="mx-auto d-block" width="150" height="150" border="0"> 
                                        </div>
                                        <div v-if="state == 'successfully'">
                                                <p>Usuario creado con éxito</p>
                                        </div>
                                <div class="modal-footer" v-if="state == 'form'">
                                        <button type="button" class="btn btn-danger" data-dismiss="modal">Cerrar</button>
                                        <button type="button" class="btn btn-success" @click="sendForm">Guardar Usuario</button>
                                </div>
                                <div class="modal-footer" v-if="state == 'successfully'">
                                        <button type="button" class="btn btn-danger" data-dismiss="modal">Cerrar</button>
                                        <button type="button" class="btn btn-success" @click="resetForm">Crear otro Usuario</button>
                                </div>
                        </div>
                </div>
        </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
        name: 'createUser',
        data(){
                return {
                        name: '',
                        last_name: '',
                        identification_document: '',
                        institution:'',
                        email: '',
                        password: '',
                        password_confirm: '',
                        rol: '',
                        state:'form',
                        pass_error: false 
                }
        },
        methods: {
                ...mapActions([
                                'createUser',
                        ]),
                async sendForm(){
                        const stad = this.compare_password()
                        console.log(stad)
                        if(stad){
                                const payload = {
                                name: this.name,
                                last_name: this.last_name,
                                identification_document: this.id,
                                institution: this.institution,
                                email: this.email,
                                password: this.password,
                                rol: this.rol
                                }
                                this.state = "load"
                                let status = await this.createUser(payload)
                                if(status.data.status == 'ok'){
                                        this.state = "successfully"
                                }
                        }

                },
                compare_password(){
                        console.log(this.password_confirm)
                        console.log(this.password)
                        if(this.password === this.password_confirm){
                                this.pass_error = false
                                return true
                        }else{
                                this.pass_error = true
                                return false
                        }
                },
                resetForm(){
                        this.state = "form"
                }
        }
}
</script>

<style>
</style>
